import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function postOrders(data) {
    
    try {
        const response = await serviceContext.post(`${ReportsURL}bets/user/history`, JSON.stringify(data), options);//"orders", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

// export async function postOrdersCsv(data) {
    
//     try {
//         const response = await serviceContext.post(ReportsURL+"orders/csv", JSON.stringify(data), options);
//         if(response.hasError === true){
//             return false;
//         }
//         else{
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

// export async function postOrdersPdf(data) {
    
//     try {
//         const response = await serviceContext.post(ReportsURL+"orders/pdf", JSON.stringify(data), options);
//         if(response.hasError === true){
//             return false;
//         }
//         else{
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

export async function postMarketBets(data) {
    
    try {
        const response = await serviceContext.post(ReportsURL+"marketbets", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
